import React, { useState, useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { getClientDomain, getToken, translate } from '../../utils/Common';
import AuthContext from '../../contexts/auth';
import ModalContext from '../../contexts/modal';
import * as BsIcons from 'react-icons/bs';
import Spinner from '../Spinner';
import ShowItems from '../ShowItems';
import CustomTooltip from '../Tooltip';
import SearchBoxItems from '../SearchBoxItems';
import ContentCard from '../layout/ContentCard';
import Button from '../common/Button';
import { ToastContainer, useToast } from '../common/Toast';
import styles from './PackagesReservation.module.css';
import { verifyAccessViewPermissions } from '../../config/permissions';

// paquetes por entregar en locker
const PackagesReservation = ({ updateTable, ItemComponent, handleUpdateTable, reservationType, selectedUser, canSearchCompany = true }) => {
    // reservationType: 1- hacer reserva, 2- entregas
    const location = useLocation();
    const userContext = useContext(AuthContext);
    const modalContext = useContext(ModalContext);
    const { toasts, showSuccess, showError, showLoading, removeToast } = useToast();
    const canUpdateReservation = verifyAccessViewPermissions(["update"], { path: location.pathname });
    const canExport = verifyAccessViewPermissions(["export"], { path: location.pathname });
    // TEMPORAL: export a Excel oculto en esta vista (no provee visibleColumns/renderers a ShowItems)
    const canExportExcel = false;
    // para validar si se encontraron paquetes
    const [awaitingDelivery, setAwaitingDelivery] = useState(null);
    const [forReservation, setForReservation] = useState(null);
    const [itemsFiltered, setItemsFiltered] = useState([]);
    const [addCounters, setAddCounters] = useState(true);
    const [itemsShowing, setItemsShowing] = useState(0);
    const [view, setView] = useState('grid');

    // hacer la reservacion de un paquete
    const confirmReservation = (paquete) => {
        if (!canUpdateReservation) {
            showError(translate("dashboard.clients.formSearch.NOT_ACCESS"), 5000);
            return;
        }
        if (reservationType === 1) {
            modalContext.confirm(translate("global.alert.attention"), 
                <span>{translate("components.packagesReservation.confirmReservation.title")} <span className="font-semibold">{paquete.NumeroIdentificacion}</span>{translate("components.packagesReservation.confirmReservation.address")} <span className="font-semibold">{paquete.Direccion}</span>{translate("components.packagesReservation.confirmReservation.question")}</span>,
                [
                    <Button
                        key={1}
                        type="button"
                        size="sm"
                        variant="primary"
                        onClick={() => sendReservations(paquete)}
                    >
                        {translate("global.yes")}
                    </Button>,
                    <Button
                        key={2}
                        type="button"
                        size="sm"
                        variant="outline"
                        onClick={() => modalContext.setIsOpenModal(false)}
                    >
                        {translate("global.no")}
                    </Button>
                ],
                true);            
        } else {
            if (paquete?.IsBoxit) {
                modalContext.confirm(translate("global.alert.doYouwantContinue"), 
                    <div className="p-0 mx-1">
                        <p className="m-0 p-0">{translate("dashboard.packages.details.optionPanel.removeReservation.cancelReservation")} <span className="font-semibold">{translate("global.door")} {paquete.Identificacion}</span>  
                        {translate("components.packagesReservation.confirmReservation.address")} <span className="font-semibold">{paquete.Direccion}</span>,
                        {translate("dashboard.packages.details.optionPanel.removeReservation.correspondingPackage")} <span className="font-semibold">{paquete.NumeroIdentificacion}</span>.</p>
                        <p>{translate("global.question.continue")}</p>
                    </div>,
                    [
                        <Button
                            key={1}
                            type="button"
                            size="sm"
                            variant="primary"
                            onClick={() => sendReservations(paquete)}
                        >
                            {translate("global.yes")}
                        </Button>,
                        <Button
                            key={2}
                            type="button"
                            size="sm"
                            variant="outline"
                            onClick={() => modalContext.setIsOpenModal(false)}
                        >
                            {translate("global.no")}
                        </Button>
                    ],
                    true);
            }
            else {
                showError(
                    `${translate("components.packagesReservation.confirmReservation.NOT_DELETE_PACKAGE")} ${translate("components.packagesReservation.confirmReservation.CHANGE_UBICATION")}`,
                    5000
                );
            }
        }
    }

    const sendReservations = async (paquete) => {
        let loadingToastId;
        try {
            let dataToSend = {};
            if (reservationType === 1) {    
                dataToSend.numeroIdentificacion = paquete.NumeroIdentificacion;
                dataToSend.clasificacion = paquete.Clasificacion;
                dataToSend.idPlataforma = paquete.IdPlataforma;
                dataToSend.alto = paquete.Alto;
                dataToSend.ancho = paquete.Ancho;
                dataToSend.largo = paquete.Largo;
            } 
            else {
                dataToSend.idPaquete = paquete.IdPaquete;
                dataToSend.idPlataforma = paquete.IdPlataforma;
            }
            modalContext.setIsOpenModal(false);

            loadingToastId = showLoading(translate("global.loading"));

            const response = await fetch(`${getClientDomain(2)}/dashboard/platforms/doors/reservation/${reservationType === 1 ? 'add' : 'remove'}` , {
                method: 'POST',
                connection: 'keep-alive',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                },
                body: JSON.stringify(dataToSend)
            });

            const result = await response.json();
            removeToast(loadingToastId);

            const payload = result?.payload;
            const firstItem = payload?.[0];
            const codigo = firstItem?.Codigo;

            if (result?.code === 200) {
                if (reservationType === 1) {
                    if (codigo === "1") {
                        showSuccess(
                            `${translate("global.modal.allReady")}: ${translate("global.numPackage")} ${paquete.NumeroIdentificacion}, ${translate("global.door")} ${firstItem.Locker} - ${paquete.Direccion}`,
                            5000
                        );
                        handleUpdateTable(!updateTable);
                    } else if (codigo === "2") {
                        showError(translate("dashboard.packages.details.optionPanel.makeReservation.noDoorsAvailable"), 5000);
                    } else if (codigo === "3") {
                        showError(translate("dashboard.packages.details.optionPanel.makeReservation.sizePackage"), 5000);
                        handleUpdateTable(!updateTable);
                    } else if (codigo === "4") {
                        showError(translate("components.packagesReservation.NOT_DOORS_AVAILABLE"), 5000);
                    } else {
                        showError(translate("dashboard.packages.details.optionPanel.makeReservation.reservationActive"), 5000);
                    }
                } else {
                    // Cancelar reserva (reservationType === 2)
                    if (codigo === "1") {
                        showSuccess(
                            `${translate("dashboard.packages.details.optionPanel.removeReservation.package")} (${paquete.NumeroIdentificacion}) ${translate("dashboard.packages.details.optionPanel.removeReservation.successfuly")}.`,
                            5000
                        );
                        handleUpdateTable(!updateTable);
                    } else {
                        showError(translate("dashboard.packages.details.optionPanel.makeReservation.error"), 5000);
                    }
                }
            } else if (result?.error || result?.code === 400 || result?.code === 404 || result?.code === 500) {
                showError(translate("global.error.request"), 5000);
            }
        } catch (error) {
            console.log(error);
            if (loadingToastId) removeToast(loadingToastId);
            showError(translate("global.error.request"), 5000);
        }
    }

    const hasPackageToCounter = () => {
        let value = reservationType === 1 ? forReservation?.filter(paquete => !paquete?.IsBoxit) : awaitingDelivery?.filter(paquete => !paquete?.IsBoxit);
        if (value?.length > 0) return true;
        else return false;
    }

    const handleFilterCounter = (isActivated) => {
        let value = itemsFiltered?.filter(paquete => paquete?.IsBoxit);
        if (isActivated){
            setAddCounters(isActivated);
            setItemsFiltered([...awaitingDelivery]);
        }
        else {
            setAddCounters(isActivated);
            setItemsFiltered([...value]);
        }
    }

    useEffect(() => {
        setAwaitingDelivery(null);
        setForReservation(null);

        const findPackages = async (user) => {
            try {
                const response = await fetch(`${getClientDomain(2)}/dashboard/packages/${ reservationType === 1 ? 'awaitingReservations' : 'awaitingDelivery' }/${user}` , {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': `Bearer ${getToken()}`
                    }
                });

                const result = await response.json();
                if (result) {
                    if (result.code === 200) {
                        if (result.payload) {
                            if (result.payload.length > 0) {
                                if (reservationType === 1) {
                                    setItemsShowing(result.payload.length <= 20 ? result.payload.length : 20);
                                    setItemsFiltered(result.payload);
                                    setForReservation(result.payload);
                                }
                                else {
                                    setItemsShowing(result.payload.length <= 20 ? result.payload.length : 20);
                                    setItemsFiltered(result.payload);
                                    setAwaitingDelivery(result.payload);
                                }
                            }
                            else {
                                setItemsShowing(0);
                                setItemsFiltered([]);
                                if (reservationType === 1) setForReservation([]);
                                else setAwaitingDelivery([]);
                            }
                        }
                    }
                    else {
                        setItemsShowing(0);
                        setItemsFiltered([]);
                        if (reservationType === 1) setForReservation([]);
                        else setAwaitingDelivery([]);
                    }
                }
            } catch (error) {
                console.log(error);
                setItemsShowing(0);
                setItemsFiltered([]);
                if (reservationType === 1) setForReservation([]);
                else setAwaitingDelivery([]);
            }
        }

        if (userContext.user?.IsAdmin) {
            if (canSearchCompany) {
                if (selectedUser !== null && selectedUser !== 0) findPackages(selectedUser);
            } else {
                const fallbackUser =
                    userContext.user?.IdUsuario != null
                        ? Number(userContext.user.IdUsuario)
                        : Number(userContext.user?.Ruc);
                if (!Number.isNaN(fallbackUser) && fallbackUser) findPackages(fallbackUser);
            }
        }
        else findPackages(userContext.user?.Ruc);
        return () => {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateTable, canSearchCompany]);

    return (
        <>
            <ToastContainer toasts={toasts} removeToast={removeToast} />
            <ContentCard padding="sm" className={styles.headerCard}>
                <div className={styles.headerRow}>
                    <h6 className={styles.title}>
                        {reservationType === 1 ? (
                            <>
                                {translate("global.pendingReservation")}
                                <CustomTooltip
                                    className={styles.tooltip}
                                    info={translate("components.packagesReservation.infoPendingReservation")}
                                />
                            </>
                        ) : (
                            <>
                                {translate("global.forDeliveryIn")}
                                <CustomTooltip
                                    className={styles.tooltip}
                                    info={translate("components.packagesReservation.infoForDeliveryIn")}
                                />
                            </>
                        )}
                    </h6>
                </div>

                {(awaitingDelivery?.length > 0 || forReservation?.length > 0) && (
                    <SearchBoxItems
                        itemsArray={reservationType === 1 ? forReservation : awaitingDelivery}
                        itemsFound={itemsFiltered}
                        setItemsShowing={setItemsShowing}
                        setItemsFiltered={setItemsFiltered}
                        view={view}
                        setView={setView}
                        itemName={reservationType === 1 ? translate("global.reservations") : translate("global.deliveries")}
                        filterType="package"
                    />
                )}

                {userContext.user?.IsAdmin && hasPackageToCounter() && (
                    <div className={styles.switchRow}>
                        <label className={styles.switchLabel} htmlFor="switchAddCounter">
                            <input
                                id="switchAddCounter"
                                type="checkbox"
                                className={styles.switchInput}
                                checked={addCounters}
                                onChange={(e) => handleFilterCounter(e.target.checked)}
                            />
                            <span className={styles.switchVisual} aria-hidden="true" />
                            <span className={styles.switchText}>
                                {translate("global.question.counterPackages")}
                            </span>
                        </label>
                    </div>
                )}
            </ContentCard>

            {(awaitingDelivery || forReservation) ? (
                <ShowItems
                    ItemComponent={ItemComponent}
                    itemsArray={reservationType === 1 ? forReservation : awaitingDelivery}
                    itemsFound={itemsFiltered}
                    setItemsFiltered={setItemsFiltered}
                    itemName={reservationType === 1 ? translate("global.reservations") : translate("global.deliveries")}
                    showBox
                    setSelectedItem={confirmReservation}
                    itemsShowing={itemsShowing}
                    view={view}
                    canExport={canExport}
                    canExportExcel={canExportExcel}
                />
            ) : (
                <ContentCard padding="md" className={styles.emptyStateCard}>
                    {userContext.user?.IsAdmin ? (
                        canSearchCompany
                            ? <span>{translate("components.packagesReservation.selectUser")}</span>
                            : <span>{translate("global.noResults")}</span>
                    ) : (
                        <div className={styles.loadingRow}>
                            <span>{translate("global.loading")}</span>
                            <div className={styles.loadingSpinner}>
                                <Spinner type={1} size={15} />
                            </div>
                        </div>
                    )}
                </ContentCard>
            )}
        </>
    );
}

export default PackagesReservation;